export default "__VITE_ASSET__mQcpqlMJ__"